import OrderFinishedCargoOrdersUnbilledListRequest, {
  OrderFinishedCargoOrdersUnbilledListRequestLackingBillingType,
  OrderFinishedCargoOrdersUnbilledListRequestOrder,
} from "../../../../api/raily/order/finished-cargo-orders/unbilled-list/order-finished-cargo-orders-unbilled-list-request";
import UnbilledOrder from "../../../../types/unbilled-order";
import OrderFinishedCargoOrdersUnbilledListParams, {
  OrderFinishedCargoOrdersUnbilledListParamsLackingBillingType,
} from "./order-finished-cargo-orders-unbilled-list-params";

const createLackingBillingType = (
  type: OrderFinishedCargoOrdersUnbilledListParamsLackingBillingType,
): OrderFinishedCargoOrdersUnbilledListRequestLackingBillingType => {
  switch (type) {
    case OrderFinishedCargoOrdersUnbilledListParamsLackingBillingType.PRIV_TAXI_2_RAILY:
      return OrderFinishedCargoOrdersUnbilledListRequestLackingBillingType.PRIV_TAXI_2_RAILY;
    case OrderFinishedCargoOrdersUnbilledListParamsLackingBillingType.PUB_CARGO_2_RAILY:
      return OrderFinishedCargoOrdersUnbilledListRequestLackingBillingType.PUB_CARGO_2_RAILY;
    case OrderFinishedCargoOrdersUnbilledListParamsLackingBillingType.PUB_RAILY_2_TAXI:
      return OrderFinishedCargoOrdersUnbilledListRequestLackingBillingType.PUB_RAILY_2_TAXI;
  }
};

const createLackingBillingTypes = (
  types:
    | OrderFinishedCargoOrdersUnbilledListParamsLackingBillingType[]
    | undefined,
):
  | OrderFinishedCargoOrdersUnbilledListRequestLackingBillingType[]
  | undefined => {
  if (!types) return undefined;

  return types.map(createLackingBillingType);
};

const createOrder = (
  order: UnbilledOrder | undefined,
): OrderFinishedCargoOrdersUnbilledListRequestOrder | undefined => {
  switch (order) {
    case UnbilledOrder.HUMAN_ID_ASC:
      return OrderFinishedCargoOrdersUnbilledListRequestOrder.HUMAN_ID_ASC;
    case UnbilledOrder.HUMAN_ID_DESC:
      return OrderFinishedCargoOrdersUnbilledListRequestOrder.HUMAN_ID_DESC;
    case UnbilledOrder.START_TIME_ASC:
      return OrderFinishedCargoOrdersUnbilledListRequestOrder.START_TIME_ASC;
    case UnbilledOrder.START_TIME_DESC:
      return OrderFinishedCargoOrdersUnbilledListRequestOrder.START_TIME_DESC;
    default:
      return undefined;
  }
};

const create = (
  params: OrderFinishedCargoOrdersUnbilledListParams,
): OrderFinishedCargoOrdersUnbilledListRequest => {
  return {
    limit: params.limit,
    address: params.address,
    client: params.client,
    dispatch: params.dispatch,
    driver: params.driver,
    endAddress: params.endAddress,
    externalId: params.externalId,
    humanId: params.humanId,
    isCancelled: params.isCancelled,
    lackingBillingType: createLackingBillingTypes(params.lackingBillingType),
    midAddress: params.midAddress,
    offset: params.offset,
    order: createOrder(params.order),
    passenger: params.passenger,
    startAddress: params.startAddress,
    startTimeSince: params.startTimeSince,
    startTimeTo: params.startTimeTo,
    taxi: params.taxi,
  };
};

const orderFinishedCargoOrdersUnbilledListParamsFactory = {
  create,
};

export default orderFinishedCargoOrdersUnbilledListParamsFactory;
